(() => {
  if (customElements.get('ni-discount-price')) return;
  customElements.define('ni-discount-price', class extends HTMLElement {
    connectedCallback() {
      this.check = this.check || (() => {
        const remaining = Number(this.dataset.until) * 1000 - Date.now();
        clearTimeout(this.timer);
        if (remaining > 0) {
          this.timer = setTimeout(this.check, Math.min(remaining, 2147483647));
        } else {
          const fallback = this.querySelector('template');
          if (fallback) this.replaceWith(fallback.content.cloneNode(true));
        }
      });
      document.addEventListener('visibilitychange', this.check);
      window.addEventListener('pageshow', this.check);
      this.check();
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.check);
      window.removeEventListener('pageshow', this.check);
    }
  });
})();
